<!-- @format -->

<div class="row teacher-rows">
  @for (responsibilityInfo of sortedResponsibilityInfos; track responsibilityInfo) {
    <div class="col-12 col-md-6 teacher-data">
      <span>
        {{ responsibilityInfo.roleUrn | codeLocalizedName | async }}
        @if (responsibilityInfo.validityPeriod.startDate || responsibilityInfo.validityPeriod.endDate) {
          <span> ({{ responsibilityInfo.validityPeriod | localDateRange }}) </span>
        }
      </span>
      <span class="teacher-name">{{ responsiblePersonsById[responsibilityInfo.personId] | personFullName }}</span>
      <span>{{ responsiblePersonsById[responsibilityInfo.personId]?.emailAddress }}</span>
      <span [class.additional-data]="responsibilityInfo.personId" [class.additional-data-no-person]="!responsibilityInfo.personId">
        {{ responsibilityInfo.text | localizedString: language }}
      </span>
    </div>
  }
</div>
@if (sortedResponsibilityInfos.length === 0) {
  <div class="form-group-mimic">-</div>
}
